import React from 'react';
import { cn } from './Table';

// Tarjetas del admin — mismas bases que Table: Tailwind sobre las CSS variables del tema.

export function Card({ className, children }: { className?: string; children: React.ReactNode }) {
  return <div className={cn('rounded-2xl border border-line bg-card p-5', className)}>{children}</div>;
}

export function CardTitle({ className, children, right }: { className?: string; children: React.ReactNode; right?: React.ReactNode }) {
  return (
    <div className={cn('mb-3 flex items-center justify-between gap-3', className)}>
      <h4 className="m-0 text-[0.95rem] font-bold text-ink">{children}</h4>
      {right}
    </div>
  );
}

// KPI: etiqueta chica arriba, número grande, subtexto opcional
export function Stat({ label, value, sub, tone, className }: {
  label: string; value: React.ReactNode; sub?: React.ReactNode;
  tone?: 'profit' | 'loss' | 'neutral'; className?: string;
}) {
  return (
    <Card className={cn('p-4', className)}>
      <div className="font-mono text-[0.64rem] font-semibold uppercase tracking-widest text-faint">{label}</div>
      <div className={cn(
        'mt-1 text-[1.45rem] font-extrabold leading-tight tabular-nums',
        tone === 'profit' && 'text-emerald-600', tone === 'loss' && 'text-red-600', !tone && 'text-ink',
      )}>{value}</div>
      {sub && <div className="mt-1 text-[0.74rem] leading-snug text-soft">{sub}</div>}
    </Card>
  );
}
